import { render, staticRenderFns } from "./Runs.vue?vue&type=template&id=0cd51b6b"
import script from "./Runs.vue?vue&type=script&lang=js"
export * from "./Runs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports